import { For, Show } from "solid-js";
import { materialValue, otherPlayer, royaltyStatus, type PlayerId } from "../../core";
import { PLAYER_ACCENT } from "../../app/config";
import type { GameController } from "../../app/controller";
import type { ChessClock } from "../../app/clock";
import { ClockReadout } from "./ChessClock";
import { PieceIcon } from "./PieceIcon";

export function PlayerStatus(props: {
  controller: GameController;
  owner: PlayerId;
  clock?: ChessClock;
}) {
  const c = props.controller;
  const state = () => c.store.state;
  const p = () => state().players[props.owner];
  const active = () => state().turn === props.owner && state().phase === "playing";
  const royalty = () => royaltyStatus(state(), props.owner);

  return (
    <div
      class="pstatus"
      classList={{ active: active(), p1: props.owner === 1, p0: props.owner === 0 }}
    >
      <div class="head">
        <span class="pname">
          <span class="swatch" style={{ background: PLAYER_ACCENT[props.owner] }} />
          {p().name}
        </span>
        <Show when={props.clock} fallback={
          <Show when={active()}>
            <span class="pill ok">TO ACT</span>
          </Show>
        }>
          {(clock) => <ClockReadout clock={clock()} owner={props.owner} />}
        </Show>
      </div>

      <div class="stat-grid">
        <span class="k">Material</span>
        <span class="v">{materialValue(state(), props.owner)}</span>
        <span class="k">Hand</span>
        <span class="v">
          {p().hand.length}/{state().config.handLimit}
        </span>
        <span class="k">Deck</span>
        <span class="v">{p().deck.length}</span>
        <span class="k">Captured</span>
        <span class="v">{p().captured.length}</span>
      </div>

      <div class="royal-line">
        <span class="pill" classList={{ ok: royalty().princeAlive, danger: !royalty().princeAlive }}>
          Prince {royalty().princeAlive ? "alive" : "fallen"}
        </span>
        <span class="pill" classList={{ ok: !royalty().inCheck, danger: royalty().inCheck }}>
          King {royalty().princeAlive ? "guarded" : royalty().inCheck ? "IN CHECK" : "safe"}
        </span>
      </div>

      <Show when={p().captured.length > 0}>
        <div class="royal-line captured-row">
          <For each={p().captured}>
            {(type) => <PieceIcon type={type} owner={otherPlayer(props.owner)} />}
          </For>
        </div>
      </Show>
    </div>
  );
}
